import { PathCardCarousel } from '@tryhackme/thm-ui-components';
import { Title } from 'src/features/home/components/title/title';
import { StyledDescription } from 'src/features/home/home.styles';
import { StyledLearnAndPracticeWrapper } from 'src/features/home/components/learn-and-practice/learn-and-practice.styles';
import { useGetLearnHacktivitiesQuery } from 'src/features/hacktivities/hacktivities.slice';
import { StyledLoader, StyledLoaderWrapper } from 'src/features/hacktivities/hacktivities.styles';
export const LearnAndPractice = () => {
  const {
    data,
    isLoading,
    isSuccess
  } = useGetLearnHacktivitiesQuery();
  const {
    paths = []
  } = data?.data ?? {};
  if (isLoading || !isSuccess) {
    return <StyledLoaderWrapper>
        <StyledLoader color="black" />
      </StyledLoaderWrapper>;
  }
  return <StyledLearnAndPracticeWrapper data-sentry-element="StyledLearnAndPracticeWrapper" data-sentry-component="LearnAndPractice" data-sentry-source-file="learn-and-practice.tsx">
      <Title title="Learn and practice through gamified lessons" isLeft data-sentry-element="Title" data-sentry-source-file="learn-and-practice.tsx" />
      <StyledDescription isLeft data-sentry-element="StyledDescription" data-sentry-source-file="learn-and-practice.tsx">
        Follow structured paths and reinforce your skills in a real-world environment by completing guided
        objective-based tasks and challenges. <br /> <br /> Learning cyber security on TryHackMe is fun and addictive.
        Earn points by answering questions, taking on challenges and maintaining your hacking streak through short
        lessons.
      </StyledDescription>
      <PathCardCarousel paths={paths} data-sentry-element="PathCardCarousel" data-sentry-source-file="learn-and-practice.tsx" />
    </StyledLearnAndPracticeWrapper>;
};